import React from 'react'
import { useQuery, useMutation } from 'urql';
import { List, Button, Spin, Result } from 'antd';

const BattleQuery = `
  query {
    Pokemons_Battle {
        id
        name
        pokemon
        description
    }
  }
`;

const DeleteQuery = `
  mutation DeleteBattle($id: uuid!) {
    delete_Pokemons_Battle(where: {id: {_eq: $id}}) {
        returning {
          id
        }
      }
  }
`;

function BattleList() {

    const [{ data, fetching, error }] = useQuery({
        query: BattleQuery,
    });

    const [mutationResult, executeMutation] = useMutation(DeleteQuery)


    const DeleteBattle = (id) => {
        executeMutation({ id })
    }

    if (fetching) return <Spin size="large" />;

    if (error) return <Result
        status="error"
        title="Fetcing Data Failed"
        subTitle="Please check you network settings"
        extra={[
            <Button type="primary" key="console">
                Try Again
            </Button>,
        ]}>
    </Result>;

    return (
        <List
            itemLayout="horizontal"
            dataSource={data.Pokemons_Battle}
            renderItem={battle => (
                <List.Item actions={[<Button onClick={() => DeleteBattle(battle.id)}>Delete</Button>]}>
                    <List.Item.Meta
                        title={battle.name}
                        description={battle.description}
                    />
                </List.Item>
            )}
        />
    )
}

export default BattleList
